export const basic = [
  { key: 'year', label: 'Year' },
  { key: 'team_id', label: 'School', class: '!text-left' },
  { key: 'games_played', label: 'GP' },
  { key: 'games_started', label: 'GS' },
  { key: 'games_appeared', label: 'App' },
  { key: 'putouts', label: 'PO' },
  { key: 'assists', label: 'A' },
  { key: 'total_chances', label: 'TC' },
  { key: 'errors', label: 'E' },
  { key: 'fielding_percentage', label: 'FPCT' },
  { key: 'catchers_interference', label: 'CI' },
  { key: 'passed_balls', label: 'PB' },
  { key: 'stolen_bases_allowed', label: 'SBA' },
  { key: 'caught_stealing_by', label: 'CSB' },
  { key: 'double_plays_turned', label: 'DPT' },
  { key: 'range_factor', label: 'RF' },
];
export const basicTeam = [
  { key: 'year', label: 'Year' },
  { key: 'games_played', label: 'GP' },
  { key: 'putouts', label: 'PO' },
  { key: 'assists', label: 'A' },
  { key: 'total_chances', label: 'TC' },
  { key: 'errors', label: 'E' },
  { key: 'fielding_percentage', label: 'FPCT' },
  { key: 'catchers_interference', label: 'CI' },
  { key: 'passed_balls', label: 'PB' },
  { key: 'stolen_bases_allowed', label: 'SBA' },
  { key: 'caught_stealing_by', label: 'CBA' },
  { key: 'double_plays_turned', label: 'DPT' },
];
